<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Medicamentos Más Recetados</h3>
                <p class="text-muted">Visualiza los medicamentos más recetados por ti.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="350" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "MedicamentosRecetados",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            chartOptions: {
                chart: {
                    type: "bar"
                },
                xaxis: {
                    categories: [] // Nombres de los medicamentos
                },
                yaxis: {
                    title: {
                        text: "Total Medicamentos"
                    }
                },
                colors: ["#40a5ff"],
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `${val} recetas`;
                        }
                    }
                }
            },
            chartSeries: []
        };
    },
    mounted() {
        this.fetchMedicamentosRecetados();
    },
    methods: {
        async fetchMedicamentosRecetados() {
            try {
                const response = await axios.get(`${API}/medicamentos_mas_recetados`, {
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    const data = response.data.data;
                    this.chartOptions.xaxis.categories = data.map(item => item.medicamento);
                    this.chartSeries = [
                        {
                            name: "Recetas",
                            data: data.map(item => item.total_recetas)
                        }
                    ];
                } else {
                    this.notify("error", "No se pudo obtener los medicamentos más recetados.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #40a5ff, #ffcd56);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
